"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var patchIcon_1 = require("../../utils/patchIcon");
var LoaderIcon_1 = require("../Icons/LoaderIcon");
var classNames = require("classnames");
exports.buttonPropTypes = {
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    iconLeft: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    iconRight: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'text-link', 'disabled']),
    colorScheme: PropTypes.oneOf(['regular', 'inverted']),
    size: PropTypes.oneOf(['normal', 'large', 'auto']),
    width: PropTypes.oneOf(['stretch', 'fix', 'auto']),
    loading: PropTypes.bool,
    renderAsSpan: PropTypes.bool
};
// Temp. fix: Use ButtonProps interface to be able to set `null` as the default value.
// This is only possible because no required props are set in ButtonProps.
// A better solution should be found for this problem.
var defaultProps = {
    icon: undefined,
    iconLeft: undefined,
    iconRight: undefined,
    variant: 'tertiary',
    size: 'normal',
    width: 'fix',
    colorScheme: 'regular',
    loading: false,
    type: 'submit',
    renderAsSpan: false
};
/**
 * The `Button` component is a wrapper around the native HTML button element.
 * It may contain icons and a loading indicator defined by the props. The styling
 * is defined by the `variant` prop.
 */
exports.Button = function (props) {
    var id = props.id, className = props.className, children = props.children, disabled = props.disabled, loading = props.loading, variant = props.variant, Icon = props.icon, IconLeft = props.iconLeft, IconRight = props.iconRight, colorScheme = props.colorScheme, size = props.size, width = props.width, renderAsSpan = props.renderAsSpan, onClick = props.onClick, other = __rest(props, ["id", "className", "children", "disabled", "loading", "variant", "icon", "iconLeft", "iconRight", "colorScheme", "size", "width", "renderAsSpan", "onClick"]);
    var icon = patchIcon_1.default(Icon, {
        className: 'ee_button__icon'
    });
    var onClickHandler = function (event) {
        if (!(loading || disabled) && onClick) {
            onClick(event);
        }
    };
    var renderInside = function () {
        var iconLeft = patchIcon_1.default(IconLeft, {
            className: 'ee_button__icon--left'
        });
        var iconRight = patchIcon_1.default(IconRight, {
            className: 'ee_button__icon--right'
        });
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "ee_button__wrapper" },
                !loading && iconLeft,
                loading && variant === 'text-link' && (React.createElement(LoaderIcon_1.default, { "aria-label": "(l\u00E4dt gerade)", className: "ee_button__icon--left", spinning: true })),
                React.createElement("span", { className: "ee_button__content" }, children),
                !loading && iconRight,
                loading && variant !== 'text-link' && (React.createElement(LoaderIcon_1.default, { "aria-label": "(l\u00E4dt gerade)", className: "ee_button__icon--right", spinning: true })))));
    };
    var renderIcon = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "ee_button__wrapper" }, !loading && icon)));
    };
    var componentClassName = classNames(className, 'ee_button', "ee_button--" + colorScheme, "ee_button--" + variant, "ee_button--size-" + size, "ee_button--width-" + width, {
        'ee_is-icon': icon,
        'ee_is-loading': loading,
        'ee_button--disabled': loading || disabled
    });
    return (renderAsSpan ?
        React.createElement("span", __assign({ id: id, role: "button", tabIndex: 0, "data-focus-id": id, className: componentClassName, onClick: onClickHandler, onKeyPress: onClickHandler }, other), icon ? renderIcon() : renderInside())
        :
            React.createElement("button", __assign({ id: id, "data-focus-id": id, disabled: loading || disabled, className: componentClassName, onClick: onClickHandler }, other), icon ? renderIcon() : renderInside()));
};
exports.Button.propTypes = exports.buttonPropTypes;
exports.Button.defaultProps = defaultProps;
exports.default = exports.Button;
//# sourceMappingURL=Button.js.map